// © Microsoft Corporation. All rights reserved.

import { DesignSystem } from "@microsoft/fast-components-styles-msft";
import { enums } from "../../../../utils/enums";
import { isDarkMode } from "@microsoft/fast-components-styles-msft";

export const ProfilePageSuperAppStyles = (config: DesignSystem) => ({
    profilePageSuperAppContainer: {

        /* RESPONSIVE CLASSES */
        ["&, &." + enums.responsiveLevels.L0]: {
            height: "calc(100vh - 20px)",
            "max-height": "calc(100vh - 20px)",
            "box-sizing": "border-box",
            "flex-direction": "column",
            "align-items": "stretch",
            "overflow-y": "scroll",
            "padding-top": "30px",
            background: isDarkMode(config) ? "#181818" :  "linear-gradient(87.44deg, #3D6CDC -5.38%, #625ABA 103.44%)",

            "& .cwt-profile-tabs-container": {
                margin: "0",
                "max-width": "100%",
                display: "flex",
                "flex-direction": "column"
            }
        }
    }
});